import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'

import * as OrgActions from 'modules/org/actions'
import * as actions from './actions'

const newsletterPlaybookId = handleActions({
  [actions.createNewsletterPlaybookSuccess]: (state, action) => action.payload.playbookId,
}, "")

const newsletterInteractionId = handleActions({
  [actions.createNewsletterPlaybookSuccess]: (state, action) => action.payload.interactionId,
}, "")

const demoRequestPlaybookId = handleActions({
  [actions.createDemoRequestPlaybookSuccess]: (state, action) => action.payload.playbookId,
}, "")

const demoRequestInteractionId = handleActions({
  [actions.createDemoRequestPlaybookSuccess]: (state, action) => action.payload.interactionId,
}, "")

const CLPSettings = handleActions({
  [actions.fetchCLPSettingsSuccess]: (state, action) => action.payload,
  [actions.updateCLPSettingsSuccess]: (state, action) => action.payload,
}, {})

const CLPSubdomain = handleActions({
  [actions.fetchCLPSubdomainSuccess]: (state, action) => action.payload.subdomain,
  [actions.setCLPSubdomain]: (state, action) => action.payload,
}, "")

const CLPCname = handleActions({
  [actions.fetchCLPCnameSuccess]: (state, action) => action.payload.cname,
}, "")

const playbookType = handleActions({
  [actions.setPlaybookType]: (state, action) => action.payload,
}, "")

const demoRequestProductName = handleActions({
  [actions.setProductName]: (state, action) =>
    action.payload,
}, "")

const demoRequestValueProp = handleActions({
  [actions.setValueProp]: (state, action) => action.payload,
}, "")

const demoRequestIndustry = handleActions({
  [actions.setIndustry]: (state, action) => action.payload,
}, "")

const companyName = handleActions({
  [OrgActions.updateEmbedSuccess]: (state, action) => action.payload.response.configuration.organizationName
}, "")

const companyUrl = handleActions({
  [OrgActions.updateEmbedSuccess]: (state, action) => action.payload.response.configuration.organizationUrl
}, "")

const companyLogoUrl = handleActions({
  [OrgActions.updateEmbedSuccess]: (state, action) => action.payload.response.configuration.theme.logoUrl
}, "")

const isWidgetVerified = handleActions({
  [actions.setWidgetVerified]: (state, action) => action.payload,
}, false)

const handle = handleActions({
  [OrgActions.updateOrgSuccess]: (state, action) => action.payload.response.handle,
}, "")

export default combineReducers({
  CLPSettings,
  CLPSubdomain,
  CLPCname,
  newsletterPlaybookId,
  newsletterInteractionId,
  demoRequestPlaybookId,
  demoRequestInteractionId,
  demoRequestProductName,
  demoRequestValueProp,
  demoRequestIndustry,
  playbookType,
  companyName,
  companyUrl,
  companyLogoUrl,
  isWidgetVerified,
  handle
})


// WEBPACK FOOTER //
// ./src/modules/playbook/reducer.js